import type { ReportMeta, ReportPage } from "store/types";

export interface PageTitleValues {
  title: string;
  subtitle: string;
}

// The title/subtitle to display for a page. Each page stores its own snapshot (page.title/subtitle);
// legacy pages created before per-page titles fall back to the global report meta.
export const getPageTitleValues = (
  page: Pick<ReportPage, "title" | "subtitle"> | undefined,
  reportMeta: Pick<ReportMeta, "title" | "subtitle">
): PageTitleValues => ({
  title: page?.title ?? reportMeta.title,
  subtitle: page?.subtitle ?? reportMeta.subtitle
});

// The initial title/subtitle a newly created page inherits: a snapshot of the nearest title page
// positioned before `beforeIndex`. Returns an empty object when no title page precedes, so the new
// page keeps the global default at render time. Callers spread this onto the new page.
export const inheritPageTitle = (
  pages: ReportPage[],
  beforeIndex: number,
  reportMeta: Pick<ReportMeta, "title" | "subtitle">
): Partial<Pick<ReportPage, "title" | "subtitle">> => {
  for (let i = Math.min(beforeIndex, pages.length) - 1; i >= 0; i--) {
    if (pages[i].layout === "title") {
      return getPageTitleValues(pages[i], reportMeta);
    }
  }
  return {};
};
